// extracted by mini-css-extract-plugin
export var carrierTab = "_4p-0";
export var carrierTabActive = "_4p-1 _4p-0";
export var carrierTabInactive = "_4p-2 _4p-0";
export var carrierTabLabel = "_4p-3";
export var carrierTabLabelActive = "_4p-4 _4p-3";
export var carrierTabLabelInactive = "_4p-5 _4p-3";
export var carrierTabPercentage = "_4p-6";
export var carrierTabPercentageActive = "_4p-7 _4p-6";
export var carrierTabPercentageInactive = "_4p-8 _4p-6";
export var carrierTabWinnable = "_4p-9";
export var carrierTabWinnableActive = "_4p-a _4p-9";
export var carrierTabWinnableInactive = "_4p-b _4p-9";
export var comparisonContainer = "_4p-d";
export var missingRateButton = "_4p-n";
export var missingRateButtonActive = "_4p-o _4p-n";
export var missingRateButtonInactive = "_4p-p _4p-n";
export var missingRateButtonLabel = "_4p-q";
export var missingRateButtonLabelActive = "_4p-r _4p-q";
export var missingRateButtonLabelInactive = "_4p-s _4p-q";
export var sidebar = "_4p-c";
export var strategyButton = "_4p-e";
export var strategyButtonActive = "_4p-f _4p-e";
export var strategyButtonDescription = "_4p-k";
export var strategyButtonDescriptionActive = "_4p-l _4p-k";
export var strategyButtonDescriptionInactive = "_4p-m _4p-k";
export var strategyButtonInactive = "_4p-g _4p-e";
export var strategyButtonLabel = "_4p-h";
export var strategyButtonLabelActive = "_4p-i _4p-h";
export var strategyButtonLabelInactive = "_4p-j _4p-h";
export var unitToggleButton = "_4p-t";
export var unitToggleButtonActive = "_4p-u _4p-t";
export var unitToggleButtonInactive = "_4p-v _4p-t";
export var unitToggleButtonLabel = "_4p-w";
export var unitToggleButtonLabelActive = "_4p-x _4p-w";
export var unitToggleButtonLabelInactive = "_4p-y _4p-w";